import { INVENTORY_ID, type InventoryItem } from '@/types/shared/player'
import { usePlayer } from '@/composables/game/player'
import { computed } from 'vue'
import GoldenTicketImage from '@/assets/images/golden-ticket.png'
import GoldTGEAllocationBoostImage from '@/assets/images/gold-allocation-boost.webp'
import SilverTGEAllocationBoostImage from '@/assets/images/silver-allocation-boost.webp'
import BronzeTGEAllocationBoostImage from '@/assets/images/bronze-allocation-boost.webp'
import DiamondMultiplierImage from '@/assets/images/diamond_multiplier.webp'
import PlatinumPassImage from '@/assets/images/platinum_pass.webp'
import EmberElementShardImage from '@/assets/images/inventory-ember-element-shard.webp'
import FrostElementShardImage from '@/assets/images/inventory-frost-element-shard.webp'
import VoltElementShardImage from '@/assets/images/inventory-volt-element-shard.webp'
import StoneElementShardImage from '@/assets/images/inventory-stone-element-shard.webp'
import ElementMultiplierImage from '@/assets/images/inventory-element-multiplier.webp'
import RainbowKeyImage from '@/assets/images/inventory-rainbow-key.webp'
import PrimeSigilImage from '@/assets/images/inventory-prime-sigil.webp'
import WinterCrownImage from '@/assets/images/inventory-winter-crown.webp'

export type PlayerInventoryItem = InventoryItem & { count: number }

export const inventoryItems: InventoryItem[] = [
  {
    id: INVENTORY_ID.WINTER_CROWN,
    name: `Winter Crown`,
    imageUrl: WinterCrownImage,
  },
  {
    id: INVENTORY_ID.PRIME_SIGIL,
    name: `Prime Sigil`,
    imageUrl: PrimeSigilImage,
  },
  {
    id: INVENTORY_ID.RAINBOW_KEY,
    name: `Rainbow Key`,
    imageUrl: RainbowKeyImage,
  },
  {
    id: INVENTORY_ID.EMBER_ELEMENT_SHARD,
    name: `Ember Element Shard`,
    imageUrl: EmberElementShardImage,
  },
  {
    id: INVENTORY_ID.FROST_ELEMENT_SHARD,
    name: `Frost Element Shard`,
    imageUrl: FrostElementShardImage,
  },
  {
    id: INVENTORY_ID.VOLT_ELEMENT_SHARD,
    name: `Volt Element Shard`,
    imageUrl: VoltElementShardImage,
  },
  {
    id: INVENTORY_ID.STONE_ELEMENT_SHARD,
    name: `Stone Element Shard`,
    imageUrl: StoneElementShardImage,
  },
  {
    id: INVENTORY_ID.ELEMENT_MULTIPLIER,
    name: `Element Multiplier`,
    imageUrl: ElementMultiplierImage,
  },
  {
    id: INVENTORY_ID.PLATINUM_PASS,
    name: `Platinum Pass`,
    imageUrl: PlatinumPassImage,
  },
  {
    id: INVENTORY_ID.DIAMOND_MULTIPLIER,
    name: `Diamond Multiplier`,
    imageUrl: DiamondMultiplierImage,
  },
  {
    id: INVENTORY_ID.TGE_ALLOCATION_BOOST,
    name: `TGE Allocation Boost`,
    imageUrl: GoldenTicketImage,
  },
  {
    id: INVENTORY_ID.GOLD_TGE_BOOST_CARD,
    name: `Gold TGE Boost Card`,
    imageUrl: GoldTGEAllocationBoostImage,
  },
  {
    id: INVENTORY_ID.SILVER_TGE_BOOST_CARD,
    name: `Silver TGE Boost Card`,
    imageUrl: SilverTGEAllocationBoostImage,
  },
  {
    id: INVENTORY_ID.BRONZE_TGE_BOOST_CARD,
    name: `Bronze TGE Boost Card`,
    imageUrl: BronzeTGEAllocationBoostImage,
  },
]
export const useInventory = () => {
  const { player } = usePlayer()

  const playerInventory = computed<PlayerInventoryItem[]>(() => {
    if (!player.value?.inventory) return []

    const inventory = inventoryItems
      .map((item) => {
        const count = player.value.inventory[item.id] ?? 0
        return {
          ...item,
          count,
        }
      })
      .filter((item) => item.count > 0)

    // Check if Element Multiplier inventory item collected which doesn't come from BE:
    const ember = player.value.inventory[INVENTORY_ID.EMBER_ELEMENT_SHARD] ?? 0
    const frost = player.value.inventory[INVENTORY_ID.FROST_ELEMENT_SHARD] ?? 0
    const volt = player.value.inventory[INVENTORY_ID.VOLT_ELEMENT_SHARD] ?? 0
    const stone = player.value.inventory[INVENTORY_ID.STONE_ELEMENT_SHARD] ?? 0

    if (Math.min(ember, frost, volt, stone) > 0) {
      const elementMultiplier = inventoryItems.find((i) => i.id === INVENTORY_ID.ELEMENT_MULTIPLIER)
      if (elementMultiplier && !inventory.some(i => i.id === INVENTORY_ID.ELEMENT_MULTIPLIER)) {
        const emberIndex = inventory.findIndex(i => i.id === INVENTORY_ID.EMBER_ELEMENT_SHARD)
        if (emberIndex !== -1) {
          inventory.splice(emberIndex, 0, {
            ...elementMultiplier,
            count: 1,
          })
        } else {
          inventory.unshift({
            ...elementMultiplier,
            count: 1,
          })
        }
      }
    }

    return inventory
  })

  return {
    playerInventory,
  }
}
